<template>
    <div>
        <div class="row form-group m-t-10">
            <div class="col-md-12">
                <a href="javascript:;" class="xe-tab-underline" v-on:click.prevent="toggleTabs('general')"
                    :class="{ 'xe-tab-line-orange': tabs.general }">
                    <trans>일반</trans>
                </a>
                <!-- <a
                    href="javascript:;"
                    class="xe-tab-underline"
                    @click="toggleTabs('chartOptions')"
                    :class="{ 'xe-tab-line-orange': tabs.chartOptions }"
                >
                    <trans>차트 옵션</trans>
                </a> -->
                <a href="javascript:;" class="xe-tab-underline" v-on:click.prevent="toggleTabs('point')"
                    :class="{ 'xe-tab-line-orange': tabs.point }">
                    <trans>관제점</trans>
                </a>
                <a href="javascript:;" class="xe-tab-underline" v-on:click.prevent="toggleTabs('processing')"
                    :class="{ 'xe-tab-line-orange': tabs.processing }">
                    <trans>데이터처리</trans>
                </a>
            </div>
        </div>

        <div class="row form-group">
            <div class="col-md-12">
                <div class="tab-content m-0 p-0">
                    <div class="tab-pane fade" :class="{ 'active show': tabs.general }">
                        <label>&nbsp;</label>
                        <!-- 항목명 -->
                        <div class="row form-group">
                            <div class="col-12">
                                <label>
                                    <h6>
                                        <i class="fa fa-check"></i>
                                        <trans>항목명</trans>
                                    </h6>
                                </label>

                                <div class="row form-group align-items-center">
                                    <div class="col-md-6">
                                        <valid-input :inputType="'text'" :inputValue.sync="copySetting.title"
                                            :rules="rules.DASHBOARD_WIDGET_ITEM_NAME_RULE" :classList="'form-control'"
                                            :NonStatus="true">
                                        </valid-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 조회기간 -->
                        <hr />
                        <div class="row">
                            <div class="col-12">
                                <label>
                                    <h6>
                                        <i class="fa fa-check"></i>
                                        <trans>조회기간</trans>
                                    </h6>
                                </label>
                            </div>
                        </div>
                        <xe-modal-self :copySetting="copySetting" :isCompare="true" />
                        <hr />
                    </div>

                    <div class="tab-pane fade" v-bind:class="{ 'active show': tabs.processing }">
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label><b>
                                        <trans>후처리</trans>
                                    </b></label>
                                <valid-textarea :inputType="'text'" :inputValue.sync="copySetting.addition.afterAction"
                                    :classList="'form-control'" :rows="5" :NonStatus="true"
                                    :rules="rules.DASHBOARD_WIDGET_POSTPROCESS_RULE">
                                </valid-textarea>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" v-bind:class="{ 'active show': tabs.point }">
                        <div v-for="(series, i) in copySetting.chart.series" :key="i">
                            <div class="row form-group">
                                <div class="col-md-4">
                                    <label>
                                        <trans>표시명</trans> {{ i + 1 }}
                                    </label>
                                    <div class="row">
                                        <div class="col-7">
                                            <b-input type="text" v-model="series.label" />
                                        </div>
                                        <div class="col-5">
                                            <energy-color-palette v-model="series.dataColor" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>
                                        <trans>관제점</trans>
                                    </label>
                                    <div :style="{ fontWeight: 'normal' }">
                                        <tree-select class="col-12 pr-0 pl-0" v-model="series.point"
                                            :options="searchPointInfoOptions" :disable-branch-nodes="true"
                                            :open-on-focus="true"
                                            :placeholder="$t(controlMessages.POINT_TREE_PLACEHOLDER_MESSAGE)"
                                            :noChildrenText="$t(controlMessages.POINT_TREE_NOCHILDERN_MESSAGE)"
                                            :noResultsText="$t(controlMessages.COMMON_TREE_NOSEARCH_MESSAGE)"
                                            @input="onPointChange(series, i)" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label>
                                        <trans>표시 단위</trans>
                                    </label>
                                    <select v-model="series.displayUnit" class="form-control">
                                        <option :value="null">원본 단위 사용</option>
                                        <optgroup v-for="(units, type) in unitOptions" :key="type" :label="type">
                                            <option v-for="unit in units" :key="unit" :value="unit">{{ unit }}</option>
                                        </optgroup>
                                    </select>
                                </div>
                                <div class="col-md-1">
                                    <label>&nbsp;</label>
                                    <b-dropdown text="" variant="default" toggle-class="btn-white" class="pull-left"
                                        style="margin-top: 25px">
                                        <b-dropdown-item @click="deleteSeries(i)">
                                            <trans>삭제</trans>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>
                            <legend></legend>
                        </div>
                        <div class="row form-group m-0">
                            <button class="btn btn-white m-auto" @click="insertSeries()">
                                <i class="fa fa-plus"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-12 p-0">
                <div slot="modal-footer" class="w-100">
                    <button class="btn btn-primary m-r-5 pull-right" @click="onModalOK()">
                        <trans>확인</trans>
                    </button>
                    <button class="btn btn-secondary pull-right m-r-10" @click="onModalCancel()">
                        <trans>취소</trans>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import backEndApi from "@src/api/backEndApi";
import xeBaseSetting from "@src/views/widget/v1/common/xeBaseSetting.js";
// import xeScatchColorPicker from "../common/xeScatchColorPicker.vue";
import * as rules from "@src/consts/ruleConsts.js";
import * as validMessage from "@src/consts/validMessageConsts.js";
import * as popupMessages from "@src/consts/popupMessageConsts";
import * as controlMessages from "@src/consts/controlMessageConsts";
import EnergyColorPalette from "@src/components/colorpalette/EnergyColorPalette.vue";
import xelib from "xelib";

const { Unit } = xelib.PointBoxV2;

// Unit.types에서 모든 단위를 평면화하여 옵션 생성
const unitOptions = (function () {
    const options = {};
    Object.keys(Unit.types).forEach((type) => {
        options[type] = Object.keys(Unit.types[type]);
    });
    return options;
})();

export default {
    extends: xeBaseSetting,
    data() {
        return {
            tabs: {
                general: true,
                processing: false,
                series: false,
                chartOptions: false,
            },
            searchPoint: null,
            searchPointInfoOptions: [],
            unitOptions: unitOptions,
            rules,
            validMessage,
            popupMessages,
            controlMessages,
        };
    },

    components: {
        // xeScatchColorPicker,
        EnergyColorPalette,
    },
    mounted() {
        this.getSearchPoint();
        // 기존 시리즈에 unit과 displayUnit이 없으면 초기화
        if (this.copySetting.chart?.series) {
            this.copySetting.chart.series.forEach((series) => {
                if (!series.unit) {
                    this.$set(series, "unit", "");
                }
                if (series.displayUnit === undefined) {
                    this.$set(series, "displayUnit", null);
                }
            });
        }
    },
    methods: {
        linePicker(e, series) {
            if (typeof e === "string") {
                series.label = e;
            } else {
                series.dataColor = e.hex8;
            }
        },
        toggleTabs(tab) {
            if (tab == "general") {
                this.tabs.general = true;
                this.tabs.point = false;
                this.tabs.processing = false;
                this.tabs.chartOptions = false;
            } else if (tab == "processing") {
                this.tabs.general = false;
                this.tabs.point = false;
                this.tabs.processing = true;
                this.tabs.chartOptions = false;
            } else if (tab == "point") {
                this.tabs.general = false;
                this.tabs.point = true;
                this.tabs.processing = false;
                this.tabs.chartOptions = false;
            } else if (tab == "chartOptions") {
                this.tabs.general = false;
                this.tabs.point = false;
                this.tabs.processing = false;
                this.tabs.chartOptions = true;
            }
        },
        insertSeries() {
            this.copySetting.chart.series.push({
                type: "horizontalBar",
                label: "Default",
                point: "",
                unit: "",
                displayUnit: null,
                backgroundColor: "rgba(52, 143, 226, 0.3)",
                dataColor: "#000000",
            });
        },
        onPointChange(series,) {
            // 관제점이 변경되면 해당 관제점의 unit을 가져와서 설정
            if (series.point) {
                const find = this.searchPoint?.find((point) =>
                    point.pointList.some((pt) => pt.ptAddr === series.point)
                );
                const findPoint = find?.pointList?.find((pt) => pt.ptAddr === series.point);
                if (findPoint && findPoint.unit) {
                    this.$set(series, "unit", findPoint.unit);
                }
            }
        },
        async onModalOK() {
            // 각 시리즈의 unit과 displayUnit을 저장
            this.copySetting.chart?.series?.forEach((item) => {
                const find = this.searchPoint?.find((point) =>
                    point.pointList.some((pt) => pt.ptAddr === item.point)
                );
                const findPoint = find?.pointList?.find((pt) => pt.ptAddr == item.point);
                if (!this.isEmpty(findPoint)) {
                    item.unit = findPoint.unit;
                }
                // displayUnit은 이미 v-model로 바인딩되어 있으므로 그대로 저장됨
                if (item.displayUnit === undefined) {
                    this.$set(item, "displayUnit", null);
                }
            });
            await this.$emit("on-modal-ok", this.copySetting);
        },
        deleteSeries(idx) {
            this.copySetting.chart.series.splice(idx, 1);
        },
        onChangeColor(idx, color) {
            this.copySetting.chart.series[idx].backgroundColor = color;
        },
        getSearchPoint() {
            this.searchPointInfoOptions = [];

            backEndApi.pointInfo.getPointByGroup().then(({ data }) => {
                this.searchPoint = data;

                this.searchPoint.map((point) => {
                    const pointList = point.pointList;
                    const groupObject = {
                        id: point.groupCode,
                        label: point.groupCodeName,
                        children: [],
                    };

                    for (let i = 0; i < pointList.length; i++) {
                        groupObject.children.push({
                            id: pointList[i].ptAddr,
                            label: pointList[i].ptName,
                        });
                    }

                    this.searchPointInfoOptions.push(groupObject);
                });

                this.searchPointInfoOptions.sort((a, b) => {
                    return a.label.localeCompare(b.label);
                });

                this.searchPointInfoOptions.unshift({
                    id: "",
                    label: "전체",
                });
            });
        },
    },
};
</script>
@src/views/widget/v1/common/xeBaseSetting.js
